module.exports = __webpack_public_path__ + "img/default-img.91b4b0c3.png";